import { RouteObject } from 'react-router'

import { ROUTES } from '@/common/constants/routes'
import { AuthenticatedLayout } from '@/common/layouts/AuthenticatedLayout'
import { SettingsLayout } from '@/common/layouts/SettingsLayout'
import General from './pages/General'
import GenericContent from './pages/GenericContent'

export const SettingsRoutes: RouteObject[] = [
  {
    element: <AuthenticatedLayout />,
    children: [
      {
        element: <SettingsLayout />,
        children: [
          { path: ROUTES.SETTINGS.GENERAL, element: <General /> },
          {
            path: ROUTES.SETTINGS.GENERIC_CONTENT,
            element: <GenericContent />,
          },
        ],
      },
    ],
  },
]
